interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, index) => index + 1);

  return (
    <div className="flex items-center justify-center gap-2 mt-10">
      <button
        type="button"
        disabled={page === 1}
        onClick={() => onChange(page - 1)}
        className="h-9 px-3 rounded-md border border-background-200 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer flex items-center gap-1 whitespace-nowrap"
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>
      {pages.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => onChange(item)}
          className={`w-9 h-9 rounded-md text-sm transition-colors cursor-pointer ${
            item === page
              ? "bg-primary-500 text-background-50"
              : "border border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
          }`}
        >
          {item}
        </button>
      ))}
      <button
        type="button"
        disabled={page === totalPages}
        onClick={() => onChange(page + 1)}
        className="h-9 px-3 rounded-md border border-background-200 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer flex items-center gap-1 whitespace-nowrap"
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </div>
  );
}